<div class="container status pago-error">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-6 text-center">
      <i class="far fa-check-circle status__icon"></i>
      <div
        *ngIf="contenido && contenido.titulo"
        [innerHTML]="contenidoTitulo"
      ></div>
      <div
        *ngIf="contenido && contenido.descripcion"
        class="contenedor-info-estado-pago"
      >
        <i class="far fa-check-circle contenedor-info-estado-pago__icono"></i>
        <div [innerHTML]="contenidoDescripcion"></div>
      </div>

      <div *ngIf="isSoat()" class="contenedor-info-estado-pago__encuesta">
        <img
          src="../../../../../assets/images/calificacion.gif"
          alt="Encuesta"
        />
        <div
          *ngIf="contenido && contenido.textoEncuestaDeSatisfaccion"
          [innerHTML]="contenidoTextoEncuestaDeSatisfaccion"
          class="mb-2 contenedor-info-estado-pago__texto"
        ></div>
        <a
          class="p-2 px-4 contenedor-info-estado-pago__encuesta-link"
          href="{{ pago.encuestaSatisfaccion }}"
          target="_blank"
          >Califica tu experiencia</a
        >
      </div>

      <app-resumen-pago
        [referencia]="pago.referencia"
        [resumenesDePago]="resumenesDePago"
      ></app-resumen-pago>
    </div>
    <div class="col-12 d-flex justify-content-center my-5">
      <a (click)="regresarAlComercio(pago.urlRetorno)" class="go-back"
        >Regresar al comercio</a
      >
    </div>
    <div *ngIf="isSoat()" class="contenedor-info-soat">
      <p class="mt-1 contenedor-info-estado-pago__texto">
        Durante la vigencia de tu <b>SOAT</b>, podrás consultarlo en línea en:
      </p>
      <div
        class="d-flex justify-content-center align-items-center flex-column flex-sm-row"
      >
        <div class="mx-4 my-3 d-flex align-items-center">
          <span class="contenedor-info-soat__icon"></span>
          <div class="mx-3 d-flex flex-column text-left">
            <span class="contenedor-info-soat__title-link"
              >suraenlinea.com</span
            >
            <a
              href="{{ urlConsultaSoat }}"
              target="_blank"
              class="contenedor-info-soat__link"
              >Consulta tu SOAT</a
            >
          </div>
        </div>
        <div
          class="mx-4 my-3 d-flex align-items-center"
          *ngIf="tenant === 'sura'"
        >
          <span class="contenedor-info-soat__icon-app"></span>
          <div class="mx-3 d-flex flex-column text-left">
            <span class="contenedor-info-soat__title-link"
              >suraenlinea.com</span
            >
            <span class="contenedor-info-soat__title-link">
              <b class="pr-1">Descárgala</b>
              <a
                href="http://onelink.to/52hbpd"
                target="_blank"
                class="contenedor-info-soat__link"
                >aquí</a
              >
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center my-3">
      <a href="https://www.placetopay.com/web/" target="_blank">
        <img
          src="https://static.placetopay.com/placetopay-logo.svg"
          class="attachment-0x0 size-0x0 logo-placetopay"
          alt="placetopay"
          loading="lazy"
        />
      </a>
    </div>
  </div>
</div>
